export const siteInfo = {
  name: "黑料网社",
  slogan: "热帖专区，高赞神回复与加精置顶，一条龙看够",
  intro:
    "黑料网社是一个轻松向的网络吃瓜社区。我们把每天最热闹的帖子、最会说话的神回复、被版主加精置顶的热评整理在一起，让你不用翻十几个群，也能快速 get 今日最火的那件事。",
  email: "hi@heiliaowangshe.example",
  since: 2019,
};

export interface SiteStat {
  label: string;
  value: string;
  sub: string;
  icon: string;
}

export const siteStats: SiteStat[] = [
  { label: "累计发布热帖", value: "52,180", sub: "条社区内容", icon: "ri-fire-line" },
  { label: "被加精的神回复", value: "18,640", sub: "条高赞金句", icon: "ri-chat-quote-line" },
  { label: "每日围观人次", value: "260,000+", sub: "次阅读互动", icon: "ri-eye-line" },
  { label: "运营年限", value: "7", sub: "年社区沉淀", icon: "ri-history-line" },
];

export interface Testimonial {
  name: string;
  role: string;
  text: string;
  tag: string;
}

export const communityTestimonials: Testimonial[] = [
  {
    name: "晒被子的阿May",
    role: "围观三年老用户",
    text: "每天通勤打开热帖榜成了固定动作。它不给你灌鸡汤，就是让你笑一下，然后该干嘛干嘛，反而很治愈。",
    tag: "围观群众",
  },
  {
    name: "加菲不加冰",
    role: "神回复贡献者",
    text: "我最喜欢逛评论区。很多帖子的正文只是开头，后面那条神回复才是真正的正文，看一次笑一次。",
    tag: "金句制造机",
  },
  {
    name: "夜班便利店小K",
    role: "内容投稿者",
    text: "投过一次自己店里的小故事，第二天上了分类榜。没有夸张的标题，就是老老实实把事说清楚，也有人愿意看。",
    tag: "社区投稿人",
  },
];

export interface Principle {
  title: string;
  desc: string;
  icon: string;
}

export const contentPrinciples: Principle[] = [
  {
    title: "先有趣，再有用",
    desc: "我们相信轻松的内容同样有其价值。一条让人会心一笑的神回复，不比一篇长篇大论逊色。",
    icon: "ri-emotion-happy-line",
  },
  {
    title: "真实优先于刺激",
    desc: "不编造夸张细节，不消费他人隐私。日常的小事被认真写下来，本身就足够好看。",
    icon: "ri-shield-check-line",
  },
  {
    title: "评论区也是正文",
    desc: "我们重视热评与神回复，把它们当作内容的一部分来筛选和呈现，而不是可有可无的附属品。",
    icon: "ri-chat-smile-2-line",
  },
  {
    title: "克制地表达观点",
    desc: "站内内容以叙述和记录为主，不煽动情绪、不引导对立，把判断留给每位围观的人。",
    icon: "ri-scales-3-line",
  },
];

export interface Milestone {
  year: string;
  title: string;
  desc: string;
}

export const siteMilestones: Milestone[] = [
  {
    year: "2019",
    title: "从一条帖子开始",
    desc: "最初只是几个人记录日常的小论坛，第一条被顶上首页的帖子，讲的是小区门口修鞋师傅的一句话。",
  },
  {
    year: "2021",
    title: "「神回复」版块上线",
    desc: "我们发现很多帖子最精彩的地方在评论区，于是把高赞热评单独整理成板块，让人一条条看过去。",
  },
  {
    year: "2023",
    title: "热帖榜改版",
    desc: "引入分类均衡机制，让邻里、校园、手作这类小板块的优质内容也有冲出重围的机会。",
  },
  {
    year: "2026",
    title: "吃瓜日报订阅",
    desc: "推出每日精选推送，把当日最热的几条帖子和一句神回复，送到愿意每天看一眼的读者手里。",
  },
];

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "热帖榜", to: "/hot" },
  { label: "关于我们", to: "/about" },
];

export const footerGroups = [
  {
    title: "逛社区",
    links: [
      { label: "热帖榜", to: "/hot" },
      { label: "今日瓜田", to: "/hot?category=daily" },
      { label: "神回复合集", to: "/hot?category=essence" },
      { label: "网络热梗", to: "/hot?category=memes" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "内容原则", to: "/about#principles" },
      { label: "发展历程", to: "/about#milestones" },
      { label: "联系我们", to: "/about#contact" },
    ],
  },
  {
    title: "读者服务",
    links: [
      { label: "常见问题", to: "/about#faq" },
      { label: "订阅吃瓜日报", to: "/#subscribe" },
      { label: "投稿说明", to: "/about#contact" },
    ],
  },
];